export default __webpack_public_path__ + "static/media/srebrna.0ab7cab5.png";